
<!-- Inspiration: Code de Jean-François Lavigne (Sidlee) -->
<!-- https://codepen.io/jflavigne/pen/MWpKpPG -->

<div>
  <Carte :content="jel_isCarteLarge(content) ? contentCarte : content">
    <div
      :class="(jel_getClassObject(content), `carte-format-${contentCarte.formatCarte}`)"
      class="cursor-pointer d-flex h-100 flex-column carte-wrapper"
    >
      <div class="image-carte">
        <slot name="image"></slot>
      </div>
      <div v-if="afficherInfoSecondaire" class="info-secondaire">
        <slot name="infoSecondaire"></slot>
      </div>
      <div ref="texteCarte" class="card-cover">
        <slot name="infoPrimaire"></slot>
      </div>
    </div>

    <!-- <CarteMenuContextuel
      v-if="content.liensMenu"
      :content="content"
      class="card-menu-contextuel"
    ></CarteMenuContextuel> -->
  </Carte>
</div>
